const title = 'CourseManage';
const description =
  "Improve your team's learning experience. Use our platform for training development and delivery. Monetize your content. Connect with external training providers.";

const SEO = {
  title,
  description,
  canonical: 'https://coursemanage.org',
  openGraph: {
    type: 'website',
    locale: 'en_US',
    url: 'https://coursemanage.org',
    image: 'https://coursemanage.org/static/images/logo-4-without-text.png',
    title,
    description,
    images: [
      {
        url: 'https://coursemanage.org/static/images/logo-4-without-text.png',
        alt: 'CourseManage',
        width: 1280,
        height: 720
      }
    ]
  },
  twitter: {
    handle: '@__upen',
    site: 'https://twitter.com/__upen',
    cardType: 'summary_large_image'
  },
  github: {
    handle: 'homocodian',
    site: 'https://github.com/homocodian',
    cardType: 'summary_large_image'
  }
};

export { SEO };
